export default __webpack_public_path__ + "static/media/empty-icon-2.153a3f2a.png";